export var VELT_SDK_VERSION = '1.0.101';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
